import moment from "moment";
import _ from "lodash";

import PlayerPaths from "../constants/paths/playerPaths";
import ambifi from "../ambifi";


function getUtcTimestamp() {
	// ISO 8601
	return moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
}

function pushHistoryItem(tree, historyItem, srcObject) {
	const history = tree.get(PlayerPaths.ACTIVITY_HISTORY);
	if (!history || !_.isArray(history)) {
		tree.set(PlayerPaths.ACTIVITY_HISTORY, [historyItem]);
	} else {
		tree.push(PlayerPaths.ACTIVITY_HISTORY, historyItem);
	}
	ambifi.persistenceManager.trackHistory(historyItem, srcObject);
}

class History {
	openActivity(tree, identityId, activity) {
		let historyItem = {
			identityId,
			type: "activity",
			action: "open",
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, activity);
	}

	checkSection(tree, path, identityId, section) {
		let historyItem = {
			identityId,
			type: "section",
			action: "check",
			path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, section);
	}

	clearList(tree, path, identityId, list) {
		let historyItem = {
			identityId,
			type: "list",
			action: "reset",
			path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, list);
	}

	clearSection(tree, path, identityId, section) {
		let historyItem = {
			identityId,
			type: "section",
			action: "reset",
			path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, section);
	}

	checkItem(tree, path, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "check",
			path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	uncheckItem(tree, path, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "uncheck",
			path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	skipItem(tree, path, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "skip",
			path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setNotes(tree, path, notes, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setNotes",
			path,
			note: notes,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setTextInput(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setTextInput",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setDate(tree, path, identityId, item, value, valueUtc) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setDate",
			path: path,
			value,
			valueUtc,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setPicker(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setPicker",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setRanking(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setRanking",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setYesNo(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setYesNo",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setBarcode(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setBarcode",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	clearBarcode(tree, path, identityId, item) {
		let historyItem = {
			identityId,
			type: "item",
			action: "clearBarcode",
			path,
			value: "",
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setMediaAttachment(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setMediaAttachment",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	resetItemsInRange(tree, path, identityId, activity) {
		let historyItem = {
			identityId,
			type: "activity", //should this be activity level or just an item?
			action: "resetItemsInRange",
			path,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, activity);
	}

	clearMediaAttachment(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "clearMediaAttachment",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setImagePicker(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setImagePicker",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setSketchPad(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setSketchPad",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	clearSketchPad(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "clearSketchPad",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setLocation(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setLocation",
			path,
			value,
			timestamp: getUtcTimestamp()
		};

		pushHistoryItem(tree, historyItem, item);
	}

	setSingleChoice(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setSingleChoice",
			path,
			value,
			timestamp: getUtcTimestamp()
		};
		pushHistoryItem(tree, historyItem, item);
	}
	setMultiChoice(tree, path, identityId, item, value) {
		let historyItem = {
			identityId,
			type: "item",
			action: "setMultiChoice",
			path,
			value,
			timestamp: getUtcTimestamp()
		};
		pushHistoryItem(tree, historyItem, item);
	}   
	setWeather(tree, path, identityId, item, value) {
		let historyItem = {
			type: "item",
			action: "setWeather",
			path,
			value,
			timestamp: getUtcTimestamp()
		};
		pushHistoryItem(tree, historyItem, item);
	}
}

export default new History();